import people from './list/sagas'
import details from './details/sagas'
import create from './create/sagas'
import trips from './trips/sagas'
import update from './update/sagas'
import destroy from './destroy/sagas'

export default [people, details, create, trips, update, destroy]
